import React from "react";
import PropTypes from "prop-types";
import { Accordion } from "react-bootstrap";

const AccordionComponents = ({
  itemsTitle,
  defaultActiveKey = "",
  isFilter = false,
  ...rest
}) => {
  return (
    <Accordion defaultActiveKey={defaultActiveKey}>
      {itemsTitle &&
        itemsTitle.map((item, i) => {
          return (
            <Accordion.Item eventKey={i}>
              <Accordion.Header className={isFilter ? "filtered" : ""}>
                {item.title}
              </Accordion.Header>
              <Accordion.Body>{item.Children}</Accordion.Body>
            </Accordion.Item>
          );
        })}
    </Accordion>
  );
};

AccordionComponents.propTypes = {
  itemsTitle: PropTypes.array,
};

export default AccordionComponents;
